import styled from 'styled-components';

import grid from '~/styles/grid';

interface ProcessButtonProps {
  isActive: boolean;
}

export const Container = styled.div`
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${grid.lg} ${grid.xl} 8.57rem ${grid.lg} !important;
  min-height: ${() => `calc(100vh - 80px - 2.286rem - ${grid['8xl']})`};
`;

export const MenuContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: left;
  flex-direction: column;
  row-gap: ${grid.md};
`;

export const Content = styled.div``;

export const SkeletonContent = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${grid.sm};
`;

export const InstanceButton = styled.div<ProcessButtonProps>`
  align-items: center;
  cursor: pointer;
  display: flex;
  width: 100%;
  border: none;
  background: transparent;
  flex-direction: row;
  /* column-gap: ${grid.sm}; */
  text-align: left;
  font-weight: ${({ isActive }) => (isActive ? 700 : 'inherit')};

  p {
    margin-left: ${grid.lg};
  }
`;

export const InstanceImage = styled.img`
  position: absolute;
  height: ${grid.md};
  width: auto;
`;

export const EmptyNameLabel = styled.i`
  color: #808080;
`;
